import { render, staticRenderFns } from "./smallprint.vue?vue&type=template&id=736dda38&"
import script from "./smallprint.vue?vue&type=script&lang=js&"
export * from "./smallprint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports